import React, { useEffect, useState } from 'react';
import $i18n from 'panda-i18n';
import styles from './index.module.scss';
import { getTableList } from './index.services';
import { Link } from 'ice';
import newpng from './new.png';
interface List {
  tid: string;
  articleId: number;
  articleCategory: string;
  title: string;
  createTime: number;
  creator: string;
}
interface tipface {
  list: List[];
}

const TipCom = ({ ...props }) => {
  const [state, setState] = useState<tipface>({
    list: [],
  });
  useEffect(() => {
    const pageObj = {
      current: 1,
      pageSize: 10,
    };
    const form = {
      articleCategory: props.name,
      articleStatus: 'Y',
    };
    getTableList(pageObj, form).then((res) => {
      setState({ list: res.list });
    });
  }, []);

  return (
    <div className={styles.noteContent} data-i18n-ignore-content>
      <div className={styles.titles}>
        <span className={styles.tit}>
          {props.name === 'MESSAGE_REMINDER'
            ? $i18n.get({ id: 'MessageReminder.four_px', dm: '消息提醒' })
            : $i18n.get({ id: 'FaqAndHelp.four_px', dm: '常见问题与帮助' })}
        </span>
        <span className={styles.more}>
          <Link to={{ pathname: '/basedata/servicelist' }}>
            {`${$i18n.get({
              id: 'More.four_px',
              dm: '更多',
            })} >`}
          </Link>
        </span>
      </div>
      <ul>
        {state.list.map((e) => {
          return (
            <li>
              {props.name === 'MESSAGE_REMINDER' && e?.isNew === 'Y' && (
                <img src={newpng} alt="" className={styles.newpng} />
              )}
              <Link to={{ pathname: `/basedata/serviclook/${e.articleId}` }}>{e.title}</Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TipCom;
